import { IApiService } from '../services/api_service';

export const inmateDevice = (siteApi: IApiService) => ({
  getByInmate: (inmateId) => {
    return siteApi.get('/inmate-device', { params: { inmateId } });
  },
  post: (data) => {
    return siteApi.post('/inmate-device', data);
  },
  delete: (account) => {
    return siteApi.delete(`/inmate-device/${account}`);
  }
});
